import { useMutation } from '@tanstack/react-query'
import { contactApi, type ContactForm } from '../../utils/api'

/**
 * お問い合わせ送信（ContactPage）。
 * 公開フォームのため認証不要。成功/失敗は呼び出し側で表示する。
 */
export function useSubmitContact() {
  return useMutation({
    mutationFn: (data: ContactForm) => contactApi.submit(data),
  })
}
